import React from 'react';

export default React.lazy(() => /* webpackPrefetch: true */ import('./AccountCheck'));
